module.exports = __webpack_public_path__ + "img/unique-2-tab.b5f6420.webp";